module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "inverse",
      "fixed": "top"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Western Water (2000-2025)")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Lower Colorado States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/arizona"
    }
  }, [_vm._v("Arizona")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/california"
    }
  }, [_vm._v("California")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/nevada"
    }
  }, [_vm._v("Nevada")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Upper Colorado States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/colorado"
    }
  }, [_vm._v("Colorado")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/new_mexico"
    }
  }, [_vm._v("New Mexico")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/utah"
    }
  }, [_vm._v("Utah")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/wyoming"
    }
  }, [_vm._v("Wyoming")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Pacific Northwest States"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/idaho"
    }
  }, [_vm._v("Idaho")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/montana"
    }
  }, [_vm._v("Montana")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/oregon"
    }
  }, [_vm._v("Oregon")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/washington"
    }
  }, [_vm._v("Washington")])], 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/texas"
    }
  }, [_vm._v("Texas")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "http://www.deanfarr.com"
    }
  }, [_vm._v("Other Visuals")])], 1)], 1)], 1), _vm._v(" "), _c('router-view', {})], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387a3305"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 372
// module chunks = 1